import { COUNTRY_COOKIE_KEY, LANGUAGE_COOKIE_KEY } from '@crehana/constants';
import { type CountryCode, LANGUAGES } from '@crehana/ts-types';
import { cookies } from '@crehana/utils';

const browserCookies = cookies.getAll();

const language =
  (browserCookies[LANGUAGE_COOKIE_KEY] as LANGUAGES) || LANGUAGES.ES;
const country = (browserCookies[COUNTRY_COOKIE_KEY]?.toLocaleLowerCase() ||
  '*') as CountryCode;

export const cookieValues = {
  country,
  language,
};
